import { posthog } from '@pique/core/posthog';
import type { FC, PropsWithChildren } from 'react';
import { useCallback } from 'react';
import {
  ErrorBoundary,
  type FallbackProps as ReactErrorFallbackProps,
} from 'react-error-boundary';

import { PiqueErrorFallback } from './pique-error-fallback';

export { type FallbackProps } from './error-basic/fallback-creator';

export interface PiqueErrorBoundaryProps extends PropsWithChildren {
  height?: number | string;
  resetKeys?: unknown[];
}

export const PiqueErrorBoundary: FC<PiqueErrorBoundaryProps> = props => {
  const fallbackRender = useCallback(
    (fallbackProps: ReactErrorFallbackProps) => {
      return (
        <PiqueErrorFallback
          error={fallbackProps.error}
          resetError={fallbackProps.resetErrorBoundary}
          height={props.height}
        />
      );
    },
    [props.height]
  );

  const onError = useCallback(
    (error: Error, info: { componentStack?: string | null }) => {
      console.error('Uncaught error:', error, info.componentStack);
      posthog.captureException(error, {
        context: 'react_error_boundary',
        componentStack: info.componentStack ?? undefined,
      });
    },
    []
  );

  return (
    <ErrorBoundary
      fallbackRender={fallbackRender}
      onError={onError}
      resetKeys={props.resetKeys}
    >
      {props.children}
    </ErrorBoundary>
  );
};
